import styled from 'styled-components';

export const BarsWrapper:any=styled.div`
	height: 100px;
`;